import { render, staticRenderFns } from "./generalization.vue?vue&type=template&id=429f11c0&scoped=true&"
import script from "./generalization.vue?vue&type=script&lang=js&"
export * from "./generalization.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "429f11c0",
  null
  
)

export default component.exports